import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onClearFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-muted mb-4 md:mb-6">
        <Icon name="Search" size={32} className="text-muted-foreground" />
      </div>
      <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground mb-2 md:mb-3 text-center">
        No Projects Found
      </h3>
      <p className="text-sm md:text-base text-muted-foreground mb-6 md:mb-8 text-center max-w-md">
        We couldn't find any projects matching your current filters. Try adjusting your search criteria or clearing all filters.
      </p>
      <Button
        variant="outline"
        onClick={onClearFilters}
        iconName="RotateCcw"
        iconPosition="left"
      >
        Clear All Filters
      </Button>
    </div>
  );
};

export default EmptyState;